module.exports = require("./../_gen/openfl/Memory");